import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Image from '../../Image/Image';
const DoubleArrowIcon =
  'https://assets.askhippo.co.za/Icons/common/DoubleArrow_White.svg';

const GuidePartnerLaunchPad = (props) => {
  const isMobile = Boolean(props.isMobile);
  const showCta = Boolean(props.buttonText && props.href);

  // ---------- MOBILE (UNCHANGED) ----------
  if (isMobile) {
    return (
      <Box
        component="header"
        role="banner"
        sx={{
          position: 'relative',
          width: '100%',
          backgroundColor: '#FFFFFF',
          borderRadius: '48px',
          padding: '24px',
          overflow: 'visible',
          zIndex: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',

          boxSizing: 'border-box',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Pally, sans-serif',
            fontWeight: 700,
            fontSize: '2.125rem',
            lineHeight: '2.125rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
          }}
        >
          {props.heading}
        </Typography>

        {props.subheading && (
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1.25rem',
              lineHeight: '1.25rem',
              letterSpacing: '-0.03em',
              textAlign: 'center',
              mt: 1,
              whiteSpace: 'pre-line',
            }}
          >
            {props.subheading}
          </Typography>
        )}

        {/* Image (centered like LaunchPadMobile) */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
          aria-hidden="true"
        >
          <Box
            sx={{
              height: '295px',
              marginTop: '20px',
              position: 'relative',
              overflow: 'visible',
              width: '295px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Image
              width={295}
              height={295}
              src={props.image}
              alt="Hippo"
              sx={{
                width: '100%',
                height: 'auto',
                maxHeight: '314px',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </Box>
        </Box>

        {showCta && (
          <Box sx={{ mt: '24px' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                window.location.href = props.href;
              }}
              sx={{
                height: '48px',
                borderRadius: '20px',
                backgroundColor: '#FF007A',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                color: '#FFFFFF',
                fontSize: '1rem',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#e6006d',
                },
              }}
            >
              {props.buttonText}
              <img
                src={DoubleArrowIcon}
                alt="Double arrow icon"
                width={20}
                height={20}
                style={{ display: 'block', marginLeft: '6px' }}
              />
            </Button>
          </Box>
        )}
      </Box>
    );
  }

  // ---------- DESKTOP (UPDATED TO MATCH LaunchPad STYLE) ----------
  return (
    <Box
      component="header"
      role="banner"
      sx={{
        position: 'relative',
        width: '1113px',
        maxWidth: '100%',
        backgroundColor: '#FFFFFF',
        borderRadius: '48px',
        p: '40px',
        overflow: 'visible',
        margin: '60px auto', //Was 80 before
        minHeight: '370px',
        height: 'auto',
        zIndex: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
      }}
    >
      {/* IMAGE: absolute, top-right, sitting on top of card (same as LaunchPad) */}
      <Box
        sx={{
          position: 'absolute',
          top: '-82px',
          right: '-100px',
          width: '507px', // ✅ requested
          height: '507px', // ✅ requested
          transformOrigin: 'top right',
          zIndex: 1,
        }}
        aria-hidden="true"
      >
        <Image
          width={507}
          height={507}
          src={props.image}
          alt="Hippo"
          sx={{
            width: '507px',
            height: '507px',
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </Box>

      {/* TEXT: centered, max width 659px (same as LaunchPad) */}
      <Box
        sx={{
          zIndex: 3,
          width: '659px',
          maxWidth: '100%',
          textAlign: 'center', // ✅ centered
          gap: '32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Pally, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '2.25rem', md: '4.5rem' },
            lineHeight: { xs: '2.5rem', md: '4.25rem' },
            letterSpacing: '-0.03em',
          }}
        >
          {props.heading}
        </Typography>

        {props.subheading && (
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1.25rem',
              lineHeight: '1.75rem',
              mt: 1,
              whiteSpace: 'pre-line',
            }}
          >
            {props.subheading}
          </Typography>
        )}

        {showCta && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: '24px' }}>
            <Button
              variant="contained"
              onClick={() => {
                window.location.href = props.href;
              }}
              sx={{
                borderRadius: '20px',
                backgroundColor: '#FF007A',
                padding: '12px 24px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                color: '#FFFFFF',
                fontSize: '1.25rem',
                textTransform: 'none',
                minHeight: '48px',
                '&:hover': {
                  backgroundColor: '#e6006d',
                },
              }}
            >
              {props.buttonText}
              <img
                src={DoubleArrowIcon}
                alt="Double arrow icon"
                width={20}
                height={20}
                style={{ display: 'block', marginLeft: '6px' }}
              />
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GuidePartnerLaunchPad;
